import { useResolve } from '@visiba/instantiation';
import { useMisbehavedForceUpdate } from '@visiba/react-std';
import { useLayoutEffect } from 'react';
import { AuthService, User } from './auth.service';

export function useUser(): User | null {
	const authService = useResolve(AuthService);
	const update = useMisbehavedForceUpdate();

	useLayoutEffect(() => {
		const cb = (_: User) => {
			update();
		};
		const disposers = [authService.on('onAuthenticationTermination', cb), authService.on('onSuccessfulAuthentication', cb)];

		return () => {
			disposers.forEach((d) => d());
		};
	}, [authService, update]);

	return authService.getUser();
}
